module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-contact-office"
  }, [_c('div', {
    staticClass: "custom-contact-office__background"
  }, [_c('div', {
    staticClass: "custom-contact-office__container"
  }, [_c('div', {
    staticClass: "custom-contact-office__col-left"
  }, [_c('div', {
    staticClass: "custom-contact-office__title"
  }, [_vm._v("Office Hours")]), _c('div', {
    staticClass: "custom-contact-office__office-hours"
  }, _vm._l((_vm.props.hours), function(row, i) {
    return _c('div', {
      key: i,
      staticClass: "custom-contact-office__row"
    }, [_c('div', {
      staticClass: "custom-contact-office__day",
      domProps: {
        "innerHTML": _vm._s(row.day)
      }
    }), _c('div', {
      staticClass: "custom-contact-office__hour",
      domProps: {
        "innerHTML": _vm._s(row.hours)
      }
    })])
  }), 0), _c('div', {
    staticClass: "custom-contact-office__seperator"
  }), _c('a', {
    staticClass: "custom-contact-office__phone",
    attrs: {
      "href": _vm.props.phone_link
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.phone)
    }
  }), _c('a', {
    staticClass: "custom-contact-office__address",
    attrs: {
      "href": _vm.props.address_link,
      "target": "_blank"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.address)
    }
  })]), _c('div', {
    staticClass: "custom-contact-office__col-right"
  }, [_c('FormContact')], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1698838e","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-contact-office/custom-contact-office.pug
// module id = 545
// module chunks = 1